/* global window:true */
/* global document:true */
import React from 'react';
import DetailView from '../../components/DetailView';
import { Row, Col } from 'antd';
import Layout from '../../components/layout/Layout';
import { Link } from 'react-router-dom';
import FilterSidebar from '../../components/FilterSidebar';
import dayjs from 'dayjs';

import './videoCachedView.scss';

export default function () {
    const { sliderValue, sidebarIsOpen, eventsInTrip } = this.state;
    const { selectedEvent, isFetching, user } = this.props;

    let eventInfo = [];
    if (selectedEvent && selectedEvent.telematicsData && selectedEvent.telematicsData.eventStart && selectedEvent.telematicsData.eventStartLocation) {
        eventInfo.push(
            <>
                <Row
                    key="event-type"
                    className="video-view-info-row"
                >
                    <Col xs={10}>
                        <span className='label'>Event Type</span>
                    </Col>
                    <Col xs={14}>
                        <span className='value'>{selectedEvent.telematicsData.eventType}</span>
                    </Col>
                </Row>
                <br />
            </>
        );
        eventInfo.push(
            <>
                <Row
                    key="event-start"
                    className="video-view-info-row"
                >
                    <Col xs={10}>
                        <span className='label'>Event Time</span>
                    </Col>
                    <Col xs={14}>
                        <span className='value'>{selectedEvent.telematicsData.eventStart}</span>
                    </Col>
                </Row>
                <br />
            </>
        );
        eventInfo.push(
            <>
                <Row
                    key="event-location"
                    className="video-view-info-row"
                >
                    <Col xs={10}>
                        <span className='label'>Event Location</span>
                    </Col>
                    <Col xs={14}>
                        <span className='value'>{selectedEvent.telematicsData.eventStartLocation}</span>
                    </Col>
                </Row>
                <br />
            </>
        );
    }
    if (eventInfo.length === 0) {
        const identifyEvents = [];
        eventsInTrip.forEach((eventRow) => {
            if (!identifyEvents[eventRow.title]) {
                identifyEvents[eventRow.title] = 0;
            }
            identifyEvents[eventRow.title] += 1;
        });
        // eslint-disable-next-line no-restricted-syntax
        for (const eventRowIndex in identifyEvents) {
            if (Object.hasOwnProperty(identifyEvents, eventRowIndex)) {
                const eventRow = identifyEvents[eventRowIndex];
                eventInfo.push(
                    <>
                        <Row key={`event-info-row-${eventRowIndex}`} className="video-view-info-row">
                            <Col xs={10}><span className='label'>{eventRowIndex}</span></Col>
                            <Col xs={14}><span className='value'>found {eventRow} event(s)</span></Col>
                        </Row>
                        <br />
                    </>
                );
            }
        }
    }
    if (eventInfo.length === 0) {
        eventInfo = (
            <Row className="video-view-info-row">
                <Col xs={24}><span className='value'>No event(s) information available</span></Col>
            </Row>
        );
    }
    
    return (
        <Layout
            data-test="pages-video"
            className="video-page"
            title={<div>Video</div>}
            headerTitle={<div>Video Page</div>}
            menuPlacement="right"
            showFooter={false}
            loading={isFetching}
        >
            <div className={`content-wrap${user?.userCompany?.current_alert ? '-with-banner' : ''}`}>
                <FilterSidebar 
                    displayFilter={sidebarIsOpen}
                    onToggleFilterSidebar={this.toggleSidebar}
                    overrideTitle='Asset & Driver Info'
                >
                    <Row>
                        <Col span={24}>
                            <br />
                            <div style={{ width: '100%', textAlign: 'center' }}>
                                <img
                                    alt="Asset"
                                    src={
                                        selectedEvent?.info?.asset_picture ?
                                            selectedEvent.info.asset_picture :
                                            user?.userCompany?.company_image
                                    }
                                    style={{ width: 160, height: 160 }}
                                />
                            </div>
                            <br />
                            <div style={{ textAlign: 'left', marginLeft: 16 }}>
                                <Link 
                                    to={`/assets/view/${selectedEvent?.info?.asset_id}`}
                                >
                                    {selectedEvent?.info?.asset_name && selectedEvent?.info?.registration 
                                        ? `${selectedEvent?.info?.asset_name} [${selectedEvent?.info?.registration}]`
                                        : '-'
                                    }
                                </Link>
                                <br />
                                <br />
                                <span style={{
                                    fontSize: '12px',
                                    color: 'var(--cool-gray-60)',
                                    fontWeight: 600,
                                }}>
                                    Last Service:
                                </span>
                                &ensp;
                                {selectedEvent?.info?.last_service
                                    ? dayjs(selectedEvent.info.last_service).format('DD/MM/YYYY')
                                    : '-'
                                }
                                <br />
                                <br />
                                <Link to={`/drivers/view/${selectedEvent?.info?.user_id}`}>{selectedEvent?.info?.driver}</Link>
                            </div>
                            
                        </Col>
                        <Col span={24}>
                            <br />
                            <br />
                            <br />
                            <div style={{ width: '80%', marginLeft: '16px' }}>
                                <span className='filter-title' style={{ left: 16 }}>Event Info</span>
                                <br />
                                <br />
                                <br />
                                {eventInfo}
                            </div>
                        </Col>
                    </Row>
                </FilterSidebar>
                <div 
                    className="content"
                    style={{ 
                        opacity: isFetching ? 0 : 1,
                        height: '95vh',
                        overflow: 'hidden',
                    }}
                >
                    <div className="content-inner">
                        <section className="section">
                            <div className="section__body" style={{ height: 'calc(100vh - 48px)', overflow: 'hidden' }}>
                                <DetailView
                                    shareReportType="cache"
                                    selectedEvent={selectedEvent} 
                                    sliderValue={sliderValue}
                                    onForward={this.requestEventInfo}
                                    onRewind={this.requestEventInfo}
                                    onIncreaseOptionClick={this.requestEventInfo}
                                    onReset={this.requestEventInfo}
                                    showStreamingSectionOnLoad 
                                    showTimingPresetsFooter={false}
                                    sidebarIsOpen={sidebarIsOpen}
                                    setEventsInTrip={this.setEventsInTrip}
                                />
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
